export function handleSearchTracking(
    trackFBSearchEvent: (searchString: string, searchClick: string | null) => void,
    trackTTSearchEvent?: (searchString: string, searchClick: string | null) => void,
): void {
    try {
        const searchString = window.sessionStorage.getItem('TSC_SearchString');
        const searchClick = window.sessionStorage.getItem('TSC_SearchClick');
        if (searchClick) {
            if (searchString) {
                trackFBSearchEvent(searchString, searchClick);
                if (trackTTSearchEvent) {
                    trackTTSearchEvent(searchString, searchClick);
                }
                window.sessionStorage.removeItem('TSC_SearchString');
                window.sessionStorage.removeItem('TSC_SearchClick');
            }
        } else {
            if (searchString) {
                trackFBSearchEvent(searchString, searchClick);
                if (trackTTSearchEvent) {
                    trackTTSearchEvent(searchString, searchClick);
                }
                window.sessionStorage.removeItem('TSC_SearchString');
            }
        }
    } catch (error) {
        console.error('Error accessing sessionStorage:', error);
    }
}
